import { DeleteButton } from '@/components/Elements/Button'
import { Flex, Text } from '@chakra-ui/react'

const ReasonItem = ({
  onClick = () => {},
  isSelected = false,
  canDelete = false,
  reasonName = '(-)',
  handleDelete = () => {},
}) => {
  return (
    <Flex
      // className={`reason-item ${selectedMainReasonId === reason._id ? 'selected' : ''}`}
      onClick={onClick}
      border
      justifyContent={'space-between'}
      alignItems={'center'}
      cursor={'pointer'}
      borderRadius={'md'}
      borderColor={isSelected ? '#d0d0d0' : ''}
      bg={isSelected ? '#e0e0e0' : '#f5f5f5'}
      wordBreak={'break-word'}
      overflowWrap={'break-word'}
      transition={'all 0.2s ease-in-out'}
      _hover={{
        bg: '#eeeeee',
        transform: 'translateX(2px)',
        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.05)',
        border: '1px solid #e0e0e0',
      }}
      p="2"
    >
      <Text>{reasonName}</Text>
      {canDelete && <DeleteButton onClick={handleDelete} />}
    </Flex>
  )
}

export default ReasonItem
